import React from "react";
import { Link } from "react-router-dom";
import Header from "../Header";
import { useTranslation } from "react-i18next";

import "../../styles/theme.css";
import "../../styles/dashboard.css";
import "../../styles/ProfilesManager.css";

export default function Helprgp() {
  const { t } = useTranslation("help");

  return (
    <div className="theme-whbl">
      {/* Internal CSS */}
      <style>
        {`
          .dark-guide-table {
            width: 100%;
            border-collapse: collapse;
            table-layout: fixed;
            font-family: "Segoe UI", Arial, sans-serif;
            font-size: 14px;
            color: #e5e7eb;
            background: #111827;
            border: 1px solid #374151;
          }

          .dark-guide-table thead th {
            background: #1f2937;
            color: #fff;
            font-weight: 700;
            text-align: left;
            padding: 12px 14px;
            border: 1px solid #4b5563;
            vertical-align: middle;
          }

          .dark-guide-table tbody td {
            background: #1f2937;
            color: #fff;
            padding: 12px 14px;
            border: 1px solid #374151;
            vertical-align: top;
            line-height: 1.55;
          }

          .dark-guide-table th:nth-child(1),
          .dark-guide-table td:nth-child(1) {
            width: 23%;
          }

          .dark-guide-table th:nth-child(2),
          .dark-guide-table td:nth-child(2) {
            width: 30%;
          }

          .dark-guide-table th:nth-child(3),
          .dark-guide-table td:nth-child(3) {
            width: 47%;
          }

          @media (max-width: 768px) {
            .dark-guide-table {
              min-width: 750px;
            }
          }

          .help-row {
            display: block;
            gap: 16px;
            padding: 16px 18px;
            border-bottom: 1px solid #e5e7eb;
            align-items: flex-start;
          }

          .help-row:last-child {
            border-bottom: none;
          }

          .help-row p {
            width: 100%;
            max-width: 100%;
            margin: 0;
            font-size: 14px;
            line-height: 1.6;
            color: #fff;
          }

          .help-row img {
            width: 100%;
            max-width: 650px;
            border-radius: 6px;
            padding: 10px;
            transition: transform 0.8s ease;
            margin: 10px 0;
          }

          @media (max-width: 768px) {
            .help-row {
              flex-direction: column;
            }

            .help-row p,
            .help-row img {
              width: 100%;
              max-width: 100%;
            }
          }
        `}
      </style>

      <div className="container-fluid">
        <div className="main-container">
          {/* Main Content */}
          <main style={{ width: "100%" }}>
            <div className="dashboard">
              {/* Title */}
              <div className="pm-header">
                <h1 className="pm-title">{t("helpRgp.title")}</h1>
              </div>

              {/* Content */}
              <div
                style={{
                  backgroundColor: "#10172a",
                  borderRadius: "6px",
                  marginTop: "15px",
                  overflow: "hidden",
                }}
              >
                {/* Step 1 */}
                <div className="help-row">
                  <p>{t("helpRgp.intro.description")}</p>
                </div>

                {/* Step 2 */}
                <div className="help-row">
                  <img
                    src={t("aiEndpointOverview.intro.image")}
                    alt={t("helpRgp.section.imageAlt")}
                  />
<br/><br/>
<img
                    src={t("aiEndpointOverview.intro.image2")}
                    alt={t("helpRgp.section.imageAlt")}
                  />

<br/><br/>
<img
                    src={t("aiEndpointOverview.intro.image3")}
                    alt={t("helpRgp.section.imageAlt")}
                  />

<br/><br/>
<img
                    src={t("aiEndpointOverview.intro.image4")}
                    alt={t("helpRgp.section.imageAlt")}
                  />





                  <table className="dark-guide-table">
                    <thead>
                      <tr>
                        <th>{t("helpRgp.section.table.headers.field")}</th>
                        <th>{t("helpRgp.section.table.headers.purpose")}</th>
                        <th>{t("helpRgp.section.table.headers.detail")}</th>
                      </tr>
                    </thead>

                    <tbody>
                      <tr>
                        <td>
                          {t(
                            "helpRgp.section.table.rows.requestJson.field"
                          )}
                        </td>
                        <td>
                          {t(
                            "helpRgp.section.table.rows.requestJson.purpose"
                          )}
                        </td>
                        <td>
                          {t(
                            "helpRgp.section.table.rows.requestJson.detail"
                          )}
                        </td>
                      </tr>

                      <tr>
                        <td>
                          {t(
                            "helpRgp.section.table.rows.responseJson.field"
                          )}
                        </td>
                        <td>
                          {t(
                            "helpRgp.section.table.rows.responseJson.purpose"
                          )}
                        </td>
                        <td>
                          {t(
                            "helpRgp.section.table.rows.responseJson.detail"
                          )}
                        </td>
                      </tr>

                      <tr>
                        <td>
                          {t(
                            "helpRgp.section.table.rows.authorizationContentType.field"
                          )}
                        </td>
                        <td>
                          {t(
                            "helpRgp.section.table.rows.authorizationContentType.purpose"
                          )}
                        </td>
                        <td>
                          {t(
                            "helpRgp.section.table.rows.authorizationContentType.detail"
                          )}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </main>
        </div>
      </div>
    </div>
  );
}